// @flow
import * as React from 'react';
import idx from 'idx';
import { graphql } from 'react-apollo';
import { memoize } from 'lodash';
import update from 'immutability-helper';

import { autoMessagePollingInterval } from 'admin/constants/AutoMessages';
import GET_AUTO_MESSAGE_QUERY from 'admin/components/AdminAutoMessages/queries/GetAutoMessageByUuid.gql';

import type {
  GetAutoMessageByUuid,
  GetAutoMessageByUuid_autoMessaging_autoMessages_autoMessages,
} from 'admin/components/AdminAutoMessages/queries/__generated__/GetAutoMessageByUuid.js';

type Props = {
  children: (props: {
    loading: ?boolean,
    autoMessage: ?GetAutoMessageByUuid_autoMessaging_autoMessages_autoMessages,
    loadMoreSends: (cursor: string) => void,
  }) => React.Node,
  data: ReactApolloData<GetAutoMessageByUuid>,
  messageUuid: string,
};

class AdminAutoMessageDetailContainer extends React.Component<Props, void> {
  loadMoreSends = memoize((cursor: string) => {
    this.props.data.fetchMore({
      variables: {
        uuid: this.props.messageUuid,
        cursor,
        limit: 20,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }

        const existingSends =
          previousResult.autoMessaging.autoMessages.autoMessage.previousSends.edges;
        const newSends = fetchMoreResult.autoMessaging.autoMessages.autoMessage.previousSends.edges.slice(
          1
        );

        if (newSends.length <= 0) {
          return previousResult;
        }

        return update(previousResult, {
          autoMessage: {
            previousSends: {
              pageInfo: {
                $set: fetchMoreResult.autoMessaging.autoMessages.autoMessage.previousSends.pageInfo,
              },
              edges: { $set: [...existingSends, ...newSends] },
            },
          },
        });
      },
    });
  });

  render() {
    return this.props.children({
      loading: idx(this.props.data, _ => _.loading),
      autoMessage: idx(this.props.data, _ => _.autoMessaging.autoMessages.autoMessages[0]),
      loadMoreSends: this.loadMoreSends,
    });
  }
}

const withAutoMessages = graphql(GET_AUTO_MESSAGE_QUERY, {
  options: ({ messageUuid }) => ({
    variables: { messageUuid },
    pollInterval: autoMessagePollingInterval,
  }),
});

export { AdminAutoMessageDetailContainer };

export default withAutoMessages(AdminAutoMessageDetailContainer);
